import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Button, Col, Form, Input, Modal, Row } from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import MaterialList from '../../../../components/MaterialList'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMaterials } from '../../../../modules/material'
import { isEmpty, isUndefined } from 'lodash'

const BrandMaterialForm = (props) => {
  const { visible, onOk, onCancel, form, materials, myMaterials } =
    props
  const { getFieldDecorator, validateFields } = form
  const dispatch = useDispatch()
  const [stateList, setStateList] = useState([])
  const [filterOptions, setFilterOptions] = useState({})

  const { searchMaterial } = useSelector(
    (state) => ({
      searchMaterial: state.material.searchMaterial
    }),
    []
  )
  console.log(materials)
  console.log(searchMaterial)

  useDeepEffect(() => {
    if (!isEmpty(myMaterials) && !isUndefined(myMaterials)) {
      setStateList(myMaterials.map((item) => item.id))
    } else {
      setStateList([])
    }
  }, [myMaterials])

  async function fetchData() {
    await dispatch(fetchMaterials(filterOptions))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        if (values.keyword) {
          filterOptions.keyword = values.keyword
        }
        setFilterOptions(filterOptions)
        console.log(filterOptions)
        await dispatch(fetchMaterials(filterOptions))
      }
    })
  }
  const onClear = async (e) => {
    e.preventDefault()
    setFilterOptions((prevState) => {
      prevState.keyword = undefined
      return prevState
    })

    form.setFieldsValue({
      keyword: '',
    })
    await dispatch(fetchMaterials(filterOptions))
  }

  function onClickItem(material) {
    let added = false
    stateList.forEach((item) => {
      if (item === material.id) {
        added = true
      }
    })

    if (added) {
      setStateList((prevState) => {
        _.remove(prevState, (product) => {
          return product === material.id
        })

        return [...prevState]
      })
    } else {
      setStateList((prevState) => {
        prevState.push(material.id)
        return [...prevState]
      })
    }
  }

  const renderItemActive = (item) => {
    let active = false

    if (!_.isEmpty(stateList)) {
      stateList.forEach((material) => {
        if (material === item.id) {
          active = true
        }
      })
    }

    return active
  }

  function onSaveMaterial() {
    onOk(stateList)

  }

  return (
    <Modal
      width={1000}
      title={`${!_.isEmpty(myMaterials) ? 'Edit' : 'Add'} Material`}
      visible={visible}
      onOk={onSaveMaterial}
      onCancel={onCancel}>
      <Form onSubmit={onSubmit} layout="vertical">
        <Row type="flex" gutter={8}>
          <Col span={20}>
            <Form.Item>
              {getFieldDecorator(`keyword`)(
                <Input placeholder="Search from material" />
              )}
            </Form.Item>
          </Col>
          <Row gutter={8} type="flex" justify="start">
            <Col>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Col>
            <Col>
              <Button type="danger" onClick={(e) => onClear(e)}>
                เคลียร์
              </Button>
            </Col>
          </Row>
        </Row>
      </Form>
      <MaterialList
        materials={searchMaterial}
        renderItemActive={renderItemActive}
        onClickItem={onClickItem}
      />
    </Modal>
  )
}

BrandMaterialForm.propTypes = {
  materials: PropTypes.array.isRequired,
  myMaterials: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedBrandMaterialForm = Form.create({ name: 'BrandMaterialForm' })(
  BrandMaterialForm
)

export default WrappedBrandMaterialForm
